export default defineNuxtPlugin((nuxtApp) => {
	const setPointerDataAttr = (element, value) => {
		if (!(element instanceof HTMLElement)) return

		if (value === undefined || value === null || value === '') {
			element.removeAttribute('data-pointer')
			return
		}

		element.setAttribute('data-pointer', String(value))
	}

	nuxtApp.vueApp.directive('pointer', {
		mounted(element, binding) {
			setPointerDataAttr(element, binding.value)
		},
		updated(element, binding) {
			setPointerDataAttr(element, binding.value)
		},
		unmounted(element) {
			setPointerDataAttr(element, null)
		},
		getSSRProps(binding) {
			if (binding.value === undefined || binding.value === null || binding.value === '') {
				return {}
			}

			return { 'data-pointer': String(binding.value) }
		},
	})
})
